import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const exceptSymbolsInNumberTypeInput = ['e', 'E', '+', '-', '.'];
export const includeNegativeForCostImpact = ['e', 'E', '+', '.'];
// export const notAllowedRegExp = /^[^<>&]*$/; /* eslint-disable-line */
export const notAllowedRegExp = /^(?!.*<\s*script\s*>).*/i;

export const removeDuplicates = (data, key) => {
  return data.filter((o, idx) => {
    return !data.some((o2, idx2) => {
      return idx !== idx2 && key(o) === key(o2);
    });
  });
};

export const duplicates = (data, key) => {
  return data.filter((o, idx) => {
    return data.some((o2, idx2) => {
      return idx !== idx2 && key(o) === key(o2);
    });
  });
};

export const findUnique = (data, key) => {
  const arr = [];
  data.forEach(value => {
    if (!arr.find(item => key(item) === key(value))) {
      arr.push(value);
    }
  });
  return arr;
};
export const isEmptyObject = obj => {
  return Object.keys(obj).length === 0;
};

export const keyMapper = (data, key) => {
  return data.map(value => value[key]);
};

export const preventPasteNegative = e => {
  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedData = parseFloat(clipboardData.getData('text'));

  if (pastedData < 0) {
    e.preventDefault();
  }
};

export const stripTrailingSlash = str => {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};

export const getURL = () => {
  return `${window.location.origin.toString()}/`;
};
export const getDownloadLink = (blob, filename) => {
  const fileURL = window.URL.createObjectURL(blob);

  const alink = document.createElement('a');
  alink.href = fileURL;
  alink.download = filename;
  document.body.appendChild(alink);
  alink.click();
  setTimeout(() => {
    document.body.removeChild(alink);
    window.URL.revokeObjectURL(fileURL);
  });
};

export const isDevEnvironment =
  getURL().includes('dev-pecr') || getURL().includes('localhost');

export const ValidationMessage = (translate, existedName = '') => {
  return {
    nameRequired: translate('Field_Required'),
    notAllowedCharacters: translate('avoid_Special_Characters', {
      characters: `<, >` /* eslint-disable-line */,
      amp: '&',
    }),
    alreadyInUse: translate('existedName_already_in_use', {
      existedName: existedName,
    }),
  };
};

export const validateInputFields = (value, translate) => {
  if (notAllowedRegExp && !value.match(notAllowedRegExp)) {
    return ValidationMessage
      ? ValidationMessage(translate).notAllowedCharacters
      : '';
  } else {
    return '';
  }
};

export const validateRequiredInputField = (
  value,
  translate,
  allexistedName = []
) => {
  if (!value) {
    return ValidationMessage ? ValidationMessage(translate).nameRequired : '';
  } else if (notAllowedRegExp && !value.match(notAllowedRegExp)) {
    return ValidationMessage
      ? ValidationMessage(translate).notAllowedCharacters
      : '';
  } else if (
    allexistedName
      .map(data => data && data.toUpperCase())
      .includes(value.toUpperCase())
  ) {
    return ValidationMessage
      ? ValidationMessage(translate, value).alreadyInUse
      : '';
  } else {
    return '';
  }
};
